import { Eye, EyeOff } from 'lucide-react';
import { useForm } from "react-hook-form";
import { Outlet, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { store } from '../../Store/store';
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { UpdateUserDetail } from '../../Services/User/UserService';
import * as ForgotPasswordService from '../../Services/User/ForgotPasswordService'
// import { thunk_reset_user } from '../../Action/action';
import "./ForgotPasswordComponent.css"
import { FileIcons, HitechSettings, LoadingMessage, allowedTypes } from "../../Common/CommonVariables";

const ForgotPasswordComponent = (props) => {
    const currentBaseUrl = window.location.origin;

    const { handleModalClose } = props;
    const { register: registerPassword, watch, handleSubmit: handlePasswordSubmit, reset: resetPassword, formState: { errors } } = useForm();

    const userInfo = store.getState();
    const userData = userInfo?.userData || {};
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [userDet, setUserDet] = useState([]);
    const [currentEmailId, setCurrentEmailId] = useState(null);
    const [canResend, setCanResend] = useState(false);
    const [countdown, setCountdown] = useState(60);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const Steps = {
        SEND: "send",
        VERIFY: "verify",
        UPDATE: "update",
    };
    const [step, setStep] = useState(Steps.SEND);

    useEffect(() => {
        let interval = null;
        if (countdown > 0 && !canResend) {
            interval = setInterval(() => {
                setCountdown(countdown => countdown - 1);         //Decrement countdown
            }, 1000);
        } else if (countdown === 0) {
            setCanResend(true);
        }
        return () => clearInterval(interval);
    }, [countdown, canResend]);

    const startCountdown = () => {
        setCountdown(60);
        setCanResend(false);
    };

    const handleResendOtp = () => {
        var Tag_Name = currentBaseUrl ===  HitechSettings.baseUrl
                                                ? "HITECH" : "MHL"

        //debugger;
        setLoading(true);
        ForgotPasswordService.SendOtp(currentEmailId, Tag_Name)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    //debugger;
                    setStep(Steps.VERIFY);
                    setIsEmailVerified(true)
                    setUserDet(data.Data.User);
                    startCountdown();
                }
                else {
                    setStep(Steps.SEND)
                    setIsEmailVerified(false)
                    setUserDet([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setLoading(false)
            });
    }

    const onSubmit = (profileData) => {
        var Tag_Name = currentBaseUrl ===  HitechSettings.baseUrl
                                                ? "HITECH" : "MHL"

        //debugger;
        setLoading(true);
        if (step == Steps.SEND) {
            setCurrentEmailId(profileData.EmailId);
            ForgotPasswordService.SendOtp(profileData.EmailId, Tag_Name)
                .then(({ data }) => {
                    if (data.IsSuccess) {
                        //debugger;
                        setStep(Steps.VERIFY);
                        setIsEmailVerified(true)
                        setUserDet(data.Data.User);
                        startCountdown();
                        toast.success("OTP send successfully")
                    }
                    else {
                        setStep(Steps.SEND)
                        setIsEmailVerified(false)
                        setUserDet([])
                        toast.error(data.ResponseMessage)
                    }
                })
                .catch(() => toast.error("Something went wrong."))
                .finally(() => {
                    setLoading(false)
                });
        }

        else if (step == Steps.VERIFY) {
            //debugger;
            ForgotPasswordService.ForgotPassword_ValidateOtp(profileData.EmailId, profileData.Otp)
                .then(({ data }) => {
                    //debugger;
                    if (data.IsSuccess) {
                        setStep(Steps.UPDATE);
                        setIsOtpVerified(true)
                    }
                    else {
                        setStep(Steps.VERIFY)
                        setIsOtpVerified(false)
                        toast.error("OTP Invalid or Expired")
                    }
                })
                .catch(() => toast.error("Something went wrong."))
                .finally(() => {
                    setLoading(false)
                });
        }

        else {
            // if (profileData.OldPassword != userData.Password) {
            //     toast.error("Old Password does not match")
            //     return;
            // }
            // if (userData.Password == profileData.NewPassword) {
            //     toast.error("Old/New Password can't be same")
            //     return;
            // }

            const req_data = {
                emailId: btoa(profileData.EmailId),
                password: btoa(profileData.NewPassword),
                userid: userDet.UserId
            };


            ForgotPasswordService.ForgotPasswordUpdate(req_data).then(({ data }) => {
                if (data.IsSuccess) {
                    toast.success("User Password Updated successfully")
                    // props.dispatch(thunk_reset_user({}));
                    handleModalClose();
                    navigate("/login");
                } else {

                }
            })
                .catch(() =>
                    toast.error("Something went wrong.")
                ).finally(() => {
                    setLoading(false)
                });
        }

    };

    const passwordValidation = {
        required: "New Password is required",
        minLength: { value: 8, message: "Minimum 8 characters" },
        maxLength: { value: 12, message: "Maximum 12 characters" },
        pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*-])(?!.*\s)[A-Za-z\d#?!@$%^&*-]{8,12}$/,
            message: "Must contain uppercase, lowercase, a number, no spaces and one special characters(#?!@$%^&*-)",
        },
    };

    return (
        <>
            <div className="modal-backdrop w-100">
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-l" role="document">
                        <div className="modal-content custom-modal-content" style={{ maxWidth: '380px' }}>
                            <div className="modal-header custom-modal-header">
                                <h5 className="modal-title">Forgot Password</h5>
                                <button type="button" className="btn-close custom-modal-close-btn text-white" onClick={handleModalClose}></button>
                            </div>
                            <div className="modal-body custom-modal-body">
                                <form onSubmit={handlePasswordSubmit(onSubmit)}>
                                    {loading ?
                                        <LoadingMessage />
                                        : null}
                                    <div className="row mt-2">
                                        <div className="col-md-12">
                                            <label className="fw-bold required mb-0-5">Email</label>
                                            <input type="email" className="form-control custom-input-fpc mt-1"
                                                disabled={isEmailVerified}
                                                placeholder="Enter your registered email id"
                                                {...registerPassword("EmailId", {
                                                    required: "Please enter email ID",
                                                    pattern: {
                                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                        message: "Please enter a valid email address",
                                                    },
                                                })} />
                                        </div>
                                        {errors.EmailId && <p className="text-danger">{errors.EmailId.message}</p>}

                                        {isEmailVerified && (
                                            <>
                                                <div className="col-md-12 mb-2">
                                                    <label className="fw-bold required mb-0-5">OTP</label>
                                                    <input
                                                        type="text"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        className="form-control"
                                                        disabled={isOtpVerified}
                                                        {...registerPassword("Otp", { required: "Please enter otp" })}
                                                        placeholder="Enter OTP sent on your registered email id"
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                        }}
                                                    />
                                                </div>
                                                {errors.Otp && <p className="text-danger">{errors.Otp.message}</p>}
                                                {isOtpVerified == false && (
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <small className="text-muted">Didn't receive OTP?</small>
                                                        {canResend ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-link btn-sm p-0"
                                                                onClick={() => { handleResendOtp() }}
                                                                disabled={loading}
                                                            >
                                                                Resend OTP
                                                            </button>
                                                        ) : (
                                                            <small className="text-muted">Resend in {countdown}s</small>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {isOtpVerified && (
                                            <>
                                                {/* New Password */}
                                                <div className="col-md-12 mb-2" >
                                                    <label className="fw-bold required mb-0-5">New Password</label>
                                                    <div style={{ position: "relative" }}>
                                                        <input
                                                            type={showNewPassword ? "text" : "password"}
                                                            className="form-control"
                                                            {...registerPassword("NewPassword", passwordValidation)}
                                                            // {...registerPassword("NewPassword")}
                                                            style={{ paddingRight: "40px" }}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm position-absolute top-50 end-0 me-3"
                                                            style={{ background: "transparent", border: "none", transform: "translateY(-50%)" }}
                                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                                        >
                                                            {showNewPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                                                        </button>
                                                    </div>
                                                    {errors.NewPassword && <p className="text-danger">{errors.NewPassword.message}</p>}
                                                </div>

                                                {/* Confirm Password */}
                                                <div className="col-md-12 mb-2" >
                                                    <label className="fw-bold required mb-0-5">Confirm Password</label>
                                                    <div style={{ position: "relative" }}>
                                                        <input
                                                            type={showConfirmPassword ? "text" : "password"}
                                                            className="form-control"
                                                            {...registerPassword("ConfirmPassword", {
                                                                required: "Confirm Password is required",
                                                                validate: (value) =>
                                                                    value === watch("NewPassword") || "Passwords do not match",
                                                            })}
                                                            style={{ paddingRight: "40px" }}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm position-absolute top-50 end-0 me-3"
                                                            style={{ background: "transparent", border: "none", transform: "translateY(-50%)" }}
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                        >
                                                            {showConfirmPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                                                        </button>
                                                    </div>
                                                    {errors.ConfirmPassword && <p className="text-danger">{errors.ConfirmPassword.message}</p>}
                                                </div>
                                            </>
                                        )}

                                    </div>
                                    <div className="modal-footer custom-modal-footer">
                                        {/* <button type="button" className="btn btn-danger" onClick={handleModalClose}>Close</button> */}
                                        {step === Steps.SEND && <button type="submit" disabled={loading} className="btn custom-sumbitbtn custom-footer-btn">Send OTP</button>}
                                        {step === Steps.VERIFY && <button type="submit" disabled={loading} className="btn custom-sumbitbtn custom-footer-btn">Verify OTP</button>}
                                        {step === Steps.UPDATE && <button type="submit" disabled={loading} className="btn custom-sumbitbtn custom-footer-btn">Update Password</button>}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPasswordComponent